import Initials from './Initials';
import { InitialsProps, InitialsValueProps } from './types';

export type { InitialsProps, InitialsValueProps };
export default Initials;
